import React from "react";

function ShowSolarContract() {
    return (
        <>
            <div>ShowSolarContract</div>
        </>
    );
}

export default ShowSolarContract;
